import React from 'react';
import { Intl } from '@erecruit/core';
import {
  H3,
  RadioButtonGroup,
  Flex,
  Icon,
  Text,
  RadioButton,
  styled,
  ant,
  FlexItem,
} from '@erecruit/ui-kit';
import { DataLevel } from '@erecruit/types';

const { FormattedMessage } = Intl;

const VerticalRadioButton = styled(RadioButton)(
  ant({
    '&.radio-button-wrapper': {
      height: 77,
      width: 130,
    },
  }),
);

export const DataPreferencesCategoryPicker = Intl.injectIntl(
  ({
    selectedCategory,
    onSettingsChange,
    intl,
  }: {
    selectedCategory: DataLevel;
    onSettingsChange: (option: DataLevel) => void;
  } & Intl.InjectedIntlProps) => {
    return (
      <>
        <H3 padding={[0, 0, 6, 0]}>
          <FormattedMessage id={messageIds.vms.settings.data.recordPick} />
        </H3>
        <RadioButtonGroup
          defaultValue={selectedCategory}
          onChange={e => onSettingsChange(e.target.value)}
        >
          <Flex gutter={5} align="center">
            <VerticalRadioButton value={DataLevel.MyCompany}>
              <Flex direction="column" align="flex-start">
                <FlexItem flex={0} padding={[0, 0, 0, 3]}>
                  <Icon type="company" textual />
                </FlexItem>
                <Text>
                  {intl.formatMessage({
                    id: messageIds.vms.settings.data.myCompany,
                  })}
                </Text>
              </Flex>
            </VerticalRadioButton>
            <VerticalRadioButton value={DataLevel.MyOwn}>
              <Flex direction="column" align="flex-start">
                <FlexItem flex={0} padding={[0, 0, 0, 3]}>
                  <Icon type="user" textual />
                </FlexItem>
                <Text>
                  {intl.formatMessage({
                    id: messageIds.vms.settings.data.myOwn,
                  })}
                </Text>
              </Flex>
            </VerticalRadioButton>
          </Flex>
        </RadioButtonGroup>
      </>
    );
  },
);
